import type { ChipProps as MuiChipProps } from '@mui/material';
import { Chip as MuiChip, useMediaQuery, useTheme } from '@mui/material';
import type { Breakpoint } from '@mui/system';
import { Tooltip } from '~/components/Tooltip';

export interface ChipProps extends MuiChipProps {
  /**
   * The breakpoint at which to show the full label.
   * Below this breakpoint, only the icon will be shown.
   * @default 'lg'
   */
  labelBreakpoint?: Breakpoint;
  tooltip?: string;
}

export const Chip = ({ labelBreakpoint = 'lg', label, tooltip, ...props }: ChipProps) => {
  const theme = useTheme();
  const showLabel = useMediaQuery(theme.breakpoints.up(labelBreakpoint));

  const chip = (
    <MuiChip
      {...props}
      label={label}
      sx={{
        ...(!showLabel && {
          '& .MuiChip-label': {
            display: 'none',
          },
          '& .MuiChip-icon': {
            marginLeft: 0,
            marginRight: 0,
          },
          paddingLeft: '8px',
          paddingRight: '8px',
        }),
        ...props.sx,
      }}
    />
  );

  // With the label hidden, the tooltip is all that names the chip.
  return (
    <Tooltip describeChild={showLabel} title={tooltip || (!showLabel ? label : undefined)}>
      {chip}
    </Tooltip>
  );
};
